import { render, staticRenderFns } from "./ProjectedChart.vue?vue&type=template&id=3978bd7c&scoped=true&"
import script from "./ProjectedChart.vue?vue&type=script&lang=js&"
export * from "./ProjectedChart.vue?vue&type=script&lang=js&"
import style0 from "./ProjectedChart.vue?vue&type=style&index=0&id=3978bd7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3978bd7c",
  null
  
)

export default component.exports